<template>
  <div class="container" >
    <el-divider content-position="left">过程考核目标配置</el-divider>
    <div style="display: flex">
      <el-select
        v-model="searchArr.checkin_id"
        filterable
        remote
        reserve-keyword
        placeholder="请输入考核目标名称"
        size="mini"
        clearable
        :remote-method="searchRemoteCheckIn"
        :loading="searchLoading"
        @change="handleSearchCheckInSetting"
      >
        <el-option
          v-for="searchCheckItem in searchCheckSetting"
          :key="searchCheckItem.id"
          :label="searchCheckItem.title"
          :value="searchCheckItem.id"
        >
        </el-option>
      </el-select>
      <div style="text-align: right; flex: 1">
        <el-button type="primary" size="small" @click="checkIn"
          >录入</el-button
        >
        <el-button type="primary" size="small" @click.native="$router.push('setting_panel')">返回上一级</el-button>
      </div>
    </div>
    
    
    <el-drawer
      title="录入"
      :visible.sync="checkIndrawer"
      :direction="direction"
      :before-close="handleClose"
      size="50%"
    >
      <div style="padding: 0.2em 1.4em; margin-top: -17px">
        <el-form
          :model="checkInForm"
          ref="checkInForm"
          label-width="100px"
        >

          <el-form-item label="考核标题">
            <el-input v-model="checkInForm.check_name" size="mini"></el-input>
          </el-form-item>

          <el-form-item label="考核类型">
            <el-select v-model="checkInForm.check_type" filterable placeholder="请选择考核类型" clearable size="mini">
              <el-option v-for="option in checkTypes" :key="option.id" :label="option.process_check_name" :value="option.id">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="使用位置">
            <el-checkbox-group v-model="checkInForm.position" size="mini" @change="handleOrderType">
              <el-checkbox :label="1">订单</el-checkbox>
              <el-checkbox :label="2">线索</el-checkbox>
              <el-checkbox :label="3">商机</el-checkbox>
              <el-checkbox :label="4">客户(会员)</el-checkbox>
              <el-checkbox :label="5">公司</el-checkbox>
            </el-checkbox-group>
          </el-form-item>

          <el-form-item label="订单类型" v-if="checkInForm.position.indexOf(1) !== -1">
            <el-tag
              v-for="tag in dynamicTagsl"
              :key="tag.order_reg_id"
              closable
              :disable-transitions="false"
              @close="handleClosedl(tag.order_reg_id)"
              style="margin-left: .1rem;"
            >{{ tag.order_reg_name }}</el-tag>
            <el-select
              v-if="inputVisiblel"
              ref="saveTagInputl"
              class="input-new-tag"
              v-model="checkInForm.order_type"
              multiple
              placeholder="请选择订单类型"
              style="width: 100%"
              size="mini"
              filterable
              @focus="onBlurl"
              @change="setSelectStatusl"
            >
            <el-option v-for="reg in orderRegTypes" :key="reg.order_reg_id" :label="reg.order_reg_name"
                :value="reg.order_reg_id"></el-option>
            </el-select>
            <el-button v-else class="button-new-tag" size="small" @click="showInputl">+新增</el-button>
          </el-form-item>




          <el-form-item label="考核数量">
            <el-input v-model="checkInForm.check_num" type="number" size="mini" placeholder="例：5"></el-input>
          </el-form-item>

          <el-form-item label="考核角色">
            <el-tag
              v-for="tag in dynamicTags"
              :key="tag.id"
              closable
              :disable-transitions="false"
              @close="handleClosed(tag.id)"
              style="margin-left: .1rem;"
            >{{ tag.role_name }}</el-tag>
            <el-select
              v-if="inputVisible"
              ref="saveTagInput"
              class="input-new-tag"
              v-model="checkInForm.check_roles"
              multiple
              placeholder="请选择人员"
              style="width: 100%"
              size="mini"
              filterable
              @focus="onBlur"
              @change="setSelectStatus"
            >
            <el-option v-for="role in roles" :key="role.id" :label="role.role_name"
                :value="role.id"></el-option>
            </el-select>
            <el-button v-else class="button-new-tag" size="small" @click="showInput">+新增</el-button>
          </el-form-item>


          <el-form-item label="考核周期">
            <el-radio-group v-model="checkInForm.check_circle" size="mini">
              <el-radio-button label="1">日</el-radio-button>
              <el-radio-button label="2">周</el-radio-button>
              <el-radio-button label="3">月</el-radio-button>
              <el-radio-button label="4">年</el-radio-button>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="是否考核">
            <el-radio-group v-model="checkInForm.is_open" size="mini">
              <el-radio-button label="0">否</el-radio-button>
              <el-radio-button label="1">是</el-radio-button>
            </el-radio-group>
          </el-form-item>

          <div style="text-align: right">
            <el-button
              type="primary"
              size="mini"
              @click="submitForm"
              >添加</el-button
            >
          </div>
        </el-form>
      </div>
    </el-drawer>


    <el-drawer
      title="修改"
      :visible.sync="checkInEditDrawer"
      :direction="direction"
      :before-close="handleClose"
      size="50%"
    >
      <div style="padding: 0.2em 1.4em; margin-top: -17px">
        <el-form
          :model="editcheckInForm"
          ref="editcheckInForm"
          label-width="100px"
        >

        <el-form-item label="考核标题">
            <el-input v-model="editcheckInForm.check_name" size="mini"></el-input>
          </el-form-item>

          <el-form-item label="考核类型">
            <el-select v-model="editcheckInForm.check_type" filterable placeholder="请选择考核类型" clearable size="mini">
              <el-option v-for="option in checkTypes" :key="option.id" :label="option.process_check_name" :value="option.id">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="使用位置">
            <el-checkbox-group v-model="editcheckInForm.position" size="mini" @change="handleOrderType">
              <el-checkbox :label="1">订单</el-checkbox>
              <el-checkbox :label="2">线索</el-checkbox>
              <el-checkbox :label="3">商机</el-checkbox>
              <el-checkbox :label="4">客户(会员)</el-checkbox>
              <el-checkbox :label="5">公司</el-checkbox>
            </el-checkbox-group>
          </el-form-item>

          <el-form-item label="订单类型" v-if="editcheckInForm.position.indexOf(1) !== -1">
            <el-tag
              v-for="tag in dynamicTagsld"
              :key="tag.order_reg_id"
              closable
              :disable-transitions="false"
              @close="handleClosedld(tag.order_reg_id)"
              style="margin-left: .1rem;"
            >{{ tag.order_reg_name }}</el-tag>
            <el-select
              v-if="inputVisibleld"
              ref="saveTagInputld"
              class="input-new-tag"
              v-model="editcheckInForm.order_type"
              multiple
              placeholder="请选择订单类型"
              style="width: 100%"
              size="mini"
              filterable
              @focus="onBlurld"
              @change="setSelectStatusld"
            >
            <el-option v-for="reg in orderRegTypes" :key="reg.order_reg_id" :label="reg.order_reg_name"
                :value="reg.order_reg_id"></el-option>
            </el-select>
            <el-button v-else class="button-new-tag" size="small" @click="showInputld">+新增</el-button>
          </el-form-item>



          <el-form-item label="考核数量">
            <el-input v-model="editcheckInForm.check_num" type="number" size="mini" placeholder="例：5"></el-input>
          </el-form-item>




          <el-form-item label="考核角色">
            <el-tag
              v-for="tag in dynamicTagss"
              :key="tag.id"
              closable
              :disable-transitions="false"
              @close="handleCloseds(tag.id)"
              style="margin-left: .1rem;"
            >{{ tag.role_name }}</el-tag>
            <el-select
              v-if="inputVisibles"
              ref="saveTagInputs"
              class="input-new-tag"
              v-model="editcheckInForm.check_roles"
              multiple
              placeholder="请选择人员"
              style="width: 100%"
              size="mini"
              filterable
              @focus="onBlurs"
              @change="setSelectStatuss"
            >
            <el-option v-for="role in roles" :key="role.id" :label="role.role_name"
                :value="role.id"></el-option>
            </el-select>
            <el-button v-else class="button-new-tag" size="small" @click="showInputs">+新增</el-button>
          </el-form-item>




          <el-form-item label="考核周期">
            <el-radio-group v-model="editcheckInForm.check_circle" size="mini">
              <el-radio-button label="1">日</el-radio-button>
              <el-radio-button label="2">周</el-radio-button>
              <el-radio-button label="3">月</el-radio-button>
              <el-radio-button label="4">年</el-radio-button>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="是否考核">
            <el-radio-group v-model="editcheckInForm.is_open" size="mini">
              <el-radio-button label="0">否</el-radio-button>
              <el-radio-button label="1">是</el-radio-button>
            </el-radio-group>
          </el-form-item>


          <div style="text-align: right">
            <el-button
              type="primary"
              size="mini"
              @click="editSubmitForm"
              >修改</el-button
            >
          </div>
        </el-form>
      </div>
    </el-drawer>


    <el-table
      max-height="650"
      :data="checkInSetting"
      style="width: 100%; margin-top: 10px"
      border
      size="mini"
      :header-cell-style="{
        background: '#ecf4ff',
        color: '#333',
        fontWeight: '900',
        fontSize: '0.28rem',
      }"
    >
      <el-table-column prop="id" label="ID" width="60"></el-table-column>
      <el-table-column label="考核标题" width="80">
        <template slot-scope="scope">
          <p v-html="scope.row.title"></p>
        </template>
      </el-table-column>
      <el-table-column label="考核类型" width="80">
        <template slot-scope="scope">
          <span>{{ scope.row.proces_setting.process_check_name }}</span>
        </template>
      </el-table-column>
      <el-table-column label="使用位置" width="80">
        <template slot-scope="scope">
          <p v-html="scope.row.position_name"></p>
        </template>
      </el-table-column>、
      <el-table-column label="订单类型" width="90">
        <template slot-scope="scope">
          <p v-html="scope.row.order_type_name"></p>
        </template>
      </el-table-column>
      <el-table-column prop="check_num" label="考核数量" width="90"></el-table-column>
      <el-table-column label="考核角色" width="90">
        <template slot-scope="scope">
          <p v-html="scope.row.role_name"></p>
        </template>
      </el-table-column>
      <el-table-column label="考核周期" width="60">
        <template slot-scope="scope">
          <span v-if="scope.row.circle === 1">日</span>
          <span v-else-if="scope.row.circle === 2">周</span>
          <span v-else-if="scope.row.circle === 3">月</span>
          <span v-else-if="scope.row.circle === 4">年</span>
        </template>
      </el-table-column>
      <el-table-column label="是否考核" width="60">
        <template slot-scope="scope">
          <span v-if="scope.row.is_open === 1">是</span>
          <span v-else>否</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="120">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" content="修改" placement="top">
            <el-button
              @click.native.prevent="editRow(scope.$index, scope.row)"
              type="primary"
              size="mini"
              icon="el-icon-edit"
              circle
            >
            </el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>


    <div class="block" style="margin-top: 10px; text-align: right">
      <el-pagination
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
        layout="sizes, total, prev, pager, next, jumper"
        :total="total"
        :page-sizes="[10, 15, 30, 50, 100]"
        :page-size="checkInPerPage"
        background
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProcessCheckGoal',
  data () {
    return {

      searchArr: {
        checkin_id: ''
      },
      npage: 1,
      checkInPerPage: 10,
      total: null,
      checkInSetting: [],
      direction: 'rtl',
      searcher: null,
      searchLoading: false,
      searchCheckSetting: [],

      checkIndrawer: false,
      checkInEditDrawer: false,
      listSort: [],
      checkInForm: {
        check_name: '',
        check_type: null,
        position: [],
        order_type: [],
        check_num: 0,
        check_roles: [],
        check_circle: null,
        is_open: '1'
      },
      editcheckInForm: {
        id: null,
        check_name: '',
        check_type: null,
        position: [],
        order_type: [],
        check_num: 0,
        check_roles: [],
        check_circle: null,
        is_open: '1'
      },
      inputVisible: false,
      inputVisibles: false,
      inputVisiblel: false,
      inputVisibleld: false,
      checkTypes: [],
      orderRegTypes: [],
      roles: []
    }
  },
  mounted () {
    this.loadTable()
  },
  computed: {
    collapse () {
      return this.$store.state.collapse
    },
    dynamicTags () {
      let arr = []
      this.roles.forEach((item) => {
        this.checkInForm.check_roles.forEach((i) => {
          if (item.id === i)
            arr.push({
              id: i,
              role_name: item.role_name,
            })
        })
      })
      return arr
    },
    dynamicTagss () {
      let arr = []
      this.roles.forEach((item) => {
        this.editcheckInForm.check_roles.forEach((i) => {
          if (item.id === i)
            arr.push({
              id: i,
              role_name: item.role_name,
            })
        })
      })
      return arr
    },
    dynamicTagsl() {
      let arr = []
      this.orderRegTypes.forEach((item) => {
        this.checkInForm.order_type.forEach((i) => {
          if (item.order_reg_id === i)
            arr.push({
              order_reg_id: i,
              order_reg_name: item.order_reg_name,
            })
        })
      })
      return arr
    },
    dynamicTagsld() {
      let arr = []
      this.orderRegTypes.forEach((item) => {
        this.editcheckInForm.order_type.forEach((i) => {
          if (item.order_reg_id === i)
            arr.push({
              order_reg_id: i,
              order_reg_name: item.order_reg_name,
            })
        })
      })
      return arr
    },
  },
  methods: {
    loadTable () {
      this.$axios
        .get('api/admin/process/check/get_check_setting_goal', {
          params: {
            page: this.npage,
            perpage: this.checkInPerPage,
            searchItem: this.searcher
          }
        })
        .then(({ data }) => {
          if (data.code === 0) {
            this.checkInSetting = data.data.data
            this.checkTypes = data.checkTypes
            this.orderRegTypes = data.orderRegTypes
            this.roles = data.roles
            this.total = data.data.total
          }
        })
        .catch()
    },
    handleCurrentChange (val) {
      this.npage = val
      this.loadTable()
    },
    handleSizeChange (val) {
      this.checkInPerPage = val
      this.loadTable()
    },
    checkIn () {
      this.checkIndrawer = true
    },
    submitForm () {
      if (!this.checkInForm.check_name) {
        this.$message.error('请填写考核标题!')
        return false
      }      
      if (this.checkInForm.check_type === null) {
        this.$message.error('请选择考核类型!')
        return false
      }
      if (this.checkInForm.position.length <= 0) {
        this.$message.error('请选择使用位置!')
        return false
      }
      if (this.checkInForm.position.indexOf(1) !== -1 && this.checkInForm.order_type.length <= 0) {
        this.$message.error('使用位置包含了订单需要选择订单类型!')
        return false
      }
      if (this.checkInForm.check_num <= 0) {
        this.$message.error('请正确填写考核数量，需大于0!')
        return false
      }
      if (this.checkInForm.check_roles.length <= 0) {
        this.$message.error('请选择考核角色!')
        return false
      }
      if (this.checkInForm.check_circle === null) {
        this.$message.error('请选择考核周期!')
        return false
      }
      this.$axios
        .post('api/admin/process/check/goal/store', {
          check_data: this.checkInForm
        })
        .then(res => {
          const { data } = res
          if (data.code === 0) {
            this.$message.success(data.msg)
            this.checkIndrawer = false
            this.loadTable()
            this.resetForm()
          } else {
            this.$message.error(data.msg)
          }
        })
        .catch()
    },
    editSubmitForm () {
      if (!this.editcheckInForm.check_name) {
        this.$message.error('请填写考核标题!')
        return false
      }      
      if (this.editcheckInForm.check_type === null) {
        this.$message.error('请选择考核类型!')
        return false
      }
      if (this.editcheckInForm.position.length <= 0) {
        this.$message.error('请选择使用位置!')
        return false
      }
      if (this.editcheckInForm.position.indexOf(1) !== -1 && this.editcheckInForm.order_type.length <= 0) {
        this.$message.error('使用位置包含了订单需要选择订单类型!')
        return false
      }
      if (this.editcheckInForm.check_num <= 0) {
        this.$message.error('请正确填写考核数量，需大于0!')
        return false
      }
      if (this.editcheckInForm.check_roles.length <= 0) {
        this.$message.error('请选择考核角色!')
        return false
      }
      if (this.editcheckInForm.check_circle === null) {
        this.$message.error('请选择考核周期!')
        return false
      }
      this.$axios
        .post('api/admin/process/check/goal/edit_store', {
          check_setting: this.editcheckInForm
        })
        .then(res => {
          const { data } = res
          if (data.code === 0) {
            this.$message.success(data.msg)
            this.checkInEditDrawer = false
            this.loadTable()
            this.resetForm()
          } else {
            this.$message.error(data.msg)
          }
        })
        .catch()
    },
    editRow (index, row) {
      this.editcheckInForm.id = row.id
      this.editcheckInForm.check_name = row.title
      this.editcheckInForm.check_type = row.type_id
      this.editcheckInForm.position = row.position.split(",").map(Number)
      this.editcheckInForm.order_type = this.editcheckInForm.position.indexOf(1) !== -1 ? row.order_type.split(",").map(Number) : []
      this.editcheckInForm.check_num = row.check_num
      this.editcheckInForm.check_roles = row.check_roles.split(",").map(Number)
      this.editcheckInForm.check_circle = row.circle
      this.editcheckInForm.is_open = row.is_open
      this.checkInEditDrawer = true
    },
    searchRemoteCheckIn (query) {
      if (query !== '') {
        this.searchLoading = true
        setTimeout(() => {
          this.searchLoading = false
          this.searchItem(query)
        }, 200)
      } else {
        this.searchCheckSetting = []
      }
    },
    searchItem (query) {
      this.$axios
        .get('api/admin/process/check/goal/check_item_search', {
          params: {
            search: query
          }
        })
        .then(({ data }) => {
          if (data.code === 0) {
            this.searchCheckSetting = data.data
          }
        })
        .catch()
    },
    handleSearchCheckInSetting (query) {
      this.searcher = query
      setTimeout(() => {
        this.loadTable()
      })
    },
    handleClose (done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          this.resetForm()
          done()
        })
        .catch(_ => {})
    },
    handleClosed (id) {
      this.checkInForm.check_roles.forEach((item, index) => {
        if (item === id) this.checkInForm.check_roles.splice(index, 1)
      })
    },
    handleCloseds (id) {
      this.editcheckInForm.check_roles.forEach((item, index) => {
        if (item === id) this.editcheckInForm.check_roles.splice(index, 1)
      })
    },
    handleClosedl (id) {
      this.checkInForm.order_type.forEach((item, index) => {
        if (item === id) this.checkInForm.order_type.splice(index, 1)
      })
    },
    handleClosedld (id) {
      this.editcheckInForm.order_type.forEach((item, index) => {
        if (item === id) this.editcheckInForm.order_type.splice(index, 1)
      })
    },
    setSelectStatus () {
      this.inputVisible = false
    },
    onBlur() {
      this.$refs.saveTagInput.$refs.input.blur = () => {
        this.inputVisible = false
      }
    },
    showInput () {
      this.inputVisible = true
      this.$nextTick((_) => {
        this.$refs.saveTagInput.$refs.input.focus()
      })
    },
    setSelectStatuss () {
      this.inputVisibles = false
    },
    onBlurs() {
      this.$refs.saveTagInputs.$refs.input.blur = () => {
        this.inputVisibles = false
      }
    },
    showInputs () {
      this.inputVisibles = true
      this.$nextTick((_) => {
        this.$refs.saveTagInputs.$refs.input.focus()
      })
    },
    setSelectStatusl () {
      this.inputVisiblel = false
    },
    onBlurl() {
      this.$refs.saveTagInputl.$refs.input.blur = () => {
        this.inputVisiblel = false
      }
    },
    showInputl () {
      this.inputVisiblel = true
      this.$nextTick((_) => {
        this.$refs.saveTagInputl.$refs.input.focus()
      })
    },
    setSelectStatusld () {
      this.inputVisibleld = false
    },
    onBlurld() {
      this.$refs.saveTagInputld.$refs.input.blur = () => {
        this.inputVisibleld = false
      }
    },
    showInputld () {
      this.inputVisibleld = true
      this.$nextTick((_) => {
        this.$refs.saveTagInputld.$refs.input.focus()
      })
    },
    handleOrderType (val) {
      const values = Object.values(val)
      if (!values.includes(1)) {
        this.checkInForm.order_type = []
        this.editcheckInForm.order_type = []
      }
    },
    resetForm () {
      // 添加
      this.checkInForm.check_name = '',
      this.checkInForm.check_type = null,
      this.checkInForm.position = [],
      this.checkInForm.order_type = [],
      this.checkInForm.check_num = 0,
      this.checkInForm.check_roles = [],
      this.checkInForm.check_circle = null,
      this.checkInForm.is_open = '1'
      // 编辑
      this.editcheckInForm.id = null
      this.editcheckInForm.check_name = ''
      this.editcheckInForm.check_type = null,
      this.editcheckInForm.position = [],
      this.editcheckInForm.order_type = [],
      this.editcheckInForm.check_num = 0,
      this.editcheckInForm.check_roles = [],
      this.editcheckInForm.check_circle = null,
      this.editcheckInForm.is_open = '1'
    },
  }
}
</script>

<style  scoped>
.container {
  /* margin-left: 3.6rem; */
  padding: 1.82rem 0.4rem 0.4rem 0.4rem;
}
</style>



// WEBPACK FOOTER //
// src/pages/setting_panel/ProcessCheckGoal.vue